import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AuraComparisonModal = ({ currentUserData, targetUserData, onClose }) => {
    const { t } = useTranslation();

    const TraitComparison = ({ traitName, userScore, targetScore }) => (
        <div className="mb-4">
            <h4 className="font-bold text-lg text-center text-white mb-2">{traitName}</h4>
            <div className="flex items-center justify-between">
                <span className="text-sm font-semibold text-blue-300 w-24 text-left">{currentUserData.displayName}</span>
                <div className="w-full bg-gray-700 rounded-full h-4 mx-4">
                    <div className="bg-blue-500 h-4 rounded-full" style={{ width: `${userScore}%` }}></div>
                </div>
                <span className="text-sm font-mono text-gray-300">{userScore}%</span>
            </div>
            <div className="flex items-center justify-between mt-2">
                <span className="text-sm font-semibold text-purple-300 w-24 text-left">{targetUserData.displayName}</span>
                <div className="w-full bg-gray-700 rounded-full h-4 mx-4">
                    <div className="bg-purple-500 h-4 rounded-full" style={{ width: `${targetScore}%` }}></div>
                </div>
                <span className="text-sm font-mono text-gray-300">{targetScore}%</span>
            </div>
        </div>
    );

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="bg-gray-900/80 backdrop-blur-md p-6 rounded-lg shadow-glow max-w-lg w-full text-white relative border border-purple-500/50" onClick={(e) => e.stopPropagation()}>
                <h3 className="text-xl font-bold mb-4 text-purple-300 font-playfair text-center">{t('auraComparisonModal.title')}</h3>
                <TraitComparison traitName={t('auraComparisonModal.openness')} userScore={currentUserData.openness} targetScore={targetUserData.openness} />
                <TraitComparison traitName={t('auraComparisonModal.conscientiousness')} userScore={currentUserData.conscientiousness} targetScore={targetUserData.conscientiousness} />
                <TraitComparison traitName={t('auraComparisonModal.extraversion')} userScore={currentUserData.extraversion} targetScore={targetUserData.extraversion} />
                <TraitComparison traitName={t('auraComparisonModal.agreeableness')} userScore={currentUserData.agreeableness} targetScore={targetUserData.agreeableness} />
                <TraitComparison traitName={t('auraComparisonModal.neuroticism')} userScore={currentUserData.neuroticism} targetScore={targetUserData.neuroticism} />
                <button onClick={onClose} className="absolute top-3 right-3 p-2 rounded-full bg-gray-700/50 hover:bg-gray-600/50 transition duration-300" aria-label={t('auraComparisonModal.closeAriaLabel')}>
                    <LucideIcons.X size={20} />
                </button>
            </div>
        </div>
    );
};

export default AuraComparisonModal;